import { useState } from "react";
import { useTranslation } from "react-i18next";
import SectionHead from "../../components/shared/SectionHead";
import BillingToggle from "./BillingToggle";
import PlanCard from "./PlanCard";
import { PLANS } from "./plans";

export default function Pricing() {
  const { t } = useTranslation("landing");
  const [yearly, setYearly] = useState(false);

  return (
    <section
      id="pricing"
      className="scroll-mt-24 py-16 sm:py-20 lg:py-24"
    >
      <div className="mx-auto max-w-container px-5 sm:px-7">
        <SectionHead
          eyebrow={t("pricing.eyebrow")}
          title1={t("pricing.title1")}
          titleGrad={t("pricing.titleGrad")}
          subtitle={t("pricing.sub")}
        />

        <BillingToggle yearly={yearly} onChange={setYearly} />

        <div className="mx-auto grid max-w-[1120px] grid-cols-1 gap-5 sm:gap-6 lg:grid-cols-3">
          {PLANS.map((plan, i) => (
            <PlanCard
              key={plan.key}
              plan={plan}
              yearly={yearly}
              index={i}
            />
          ))}
        </div>
      </div>
    </section>
  );
}